import dynamic from 'next/dynamic'

export const Embedded = dynamic(() => import('./embedded'), { ssr: false })
